import { render } from "./DisputeBulkBar.vue?vue&type=template&id=7f073ccd&scoped=true"
import script from "./DisputeBulkBar.vue?vue&type=script&lang=js"
export * from "./DisputeBulkBar.vue?vue&type=script&lang=js"

import "./DisputeBulkBar.vue?vue&type=style&index=0&id=7f073ccd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f073ccd"]])

export default __exports__